// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__asvAp","addWidgetButton":"Header_addWidgetButton__2x0Ra","dashboardTabs":"Header_dashboardTabs__GRGTS","active":"Header_active__1P4mX"};